import { CHARGE_SELECTION_MODE, CustomerTypes, CycleType } from "../../../../constants/app-constants";
import { DynamicFromDataType } from "../../../../constants/dynamic-from-data-type";
import { DynamicForm } from "../../../../models/dynamic-form";
export const CustomerInvoiceFromControlNames = {
  INVOICE_DATE: 'invoiceDate',
  VALID_TILL: 'validTill',
  CUSTOMER_ID: 'customerId',
  CYCLE: 'cycle',
  CHARGE_GROUP_ID: 'chargeGroupId',
  CHARGE_SELECTION_MODE: 'chargeSelectionMode',
  BILLING_PARTY: 'billingPartyId',
  BILLING_PARTY_TYPE: 'billingPartyType',
  BILLING_ADDRESS: 'billingAddressId',
  DATE_RANGE: 'dateRange',
  DATE_RANGE_START: 'from',
  DATE_RANGE_END: 'to',
  PAYING_PARTY_ID: 'payingPartyId',
  CONTAINER_IDS: 'containerIds',
  ITEM_IDS: 'itemIds',
  BILLING_SEARCH_MODE: 'billingSearchMode',
}

export enum BillingSearchMode{
  BY_CONTAINER='BY_CONTAINER',
  BY_DOCUMENT='BY_DOCUMENT',
}

export const CustomerInvoiceFormConfig: DynamicForm = {
  "formName": "Create Customer Invoice",
  "formRows": [
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.INVOICE_DATE,
            "displayLabel": "Billing Date",
            "disabled": false,
            "placeHolder": "Select Billing Date",
            "fieldInfo": {
              "dataType": "date",
              "defaultToCurrentDate": true
            },
            "permissionConditions": {
              "readOnly": {
                "type": "any",
                "permissionIds": [
                  "FIELD_INVOICES_EDIT_BILLING_DATE"
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Billing Date is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.VALID_TILL,
            "displayLabel": "Valid Till",
            "disabled": false,
            "placeHolder": "Select Validity Date",
            "fieldInfo": {
              "dataType": "date"
            },
            "validators": [
              {
                "type": "required",
                "message": "Valid Till is required"
              }
            ]
          }
        }
      ]
    },
    {
      formGroups: [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.CUSTOMER_ID,
            "displayLabel": "Customer",
            "disabled": false,
            "placeHolder": "Select Customer",
            "returnRawValue": true,
            "fieldInfo": {
              "dataType": "picklist",
              "options": [],
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Customer is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.CYCLE,
            "displayLabel": "Cycle",
            "disabled": false,
            "placeHolder": "Select Cycle",
            "fieldInfo": {
              "dataType": "select",
              "options": Object.values(CycleType).filter(cycle => cycle.key !== CycleType.EMPTY.key),
              displayKey: 'value',
              valueKey: 'key'
            },
            "validators": [
              {
                "type": "selectRequired",
                "message": "Cycle is required"
              }
            ]
          }
        },
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.BILLING_SEARCH_MODE,
            "displayLabel": "Selection By",
            "fieldInfo": {
              "dataType": DynamicFromDataType.RADIO,
              "options": [
                {
                  "label": "Container",
                  "value": BillingSearchMode.BY_CONTAINER
                },
                {
                  "label": "Item",
                  "value": BillingSearchMode.BY_DOCUMENT
                }
              ]
            },
            "validators": [
              {
                "type": "required",
                "message": "Selection type is required"
              }
            ]
          }
        },
        {
          control: {
            label: CustomerInvoiceFromControlNames.DATE_RANGE,
            displayLabel: 'Gate Out Date Range',
            fieldInfo: {
              dataType: DynamicFromDataType.DATE_RANGE
            },
            validators: [
              {
                type: "required",
                message: "Gate Out Date Range is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.CONTAINER_IDS,
            "displayLabel": "Containers",
            "placeHolder": "Select Containers",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": DynamicFromDataType.PICKLIST,
              "lookupDetails": {
                "apiUrl": "v2/containers/list",
                "filterByKeys": ["CONTAINER_NO_CONTAINS"],
                "multiSelect": true,
                "limit": 10,
                "orderBy": {
                  "containerNo": "asc"
                },
                "bindLabel": "containerNo",
                "bindValue": "id",
                "displayColumns": [
                  { "key": "containerNo", "header": "Container No" },
                  { "key": "containerSize", "header": "Size" },
                  { "key": "containerType", "header": "Type" }
                ],
                "additionalFilters": []
              }
            },
            "conditions": {
              "visibility": {
                "logic": "AND",
                "rules": [
                  {
                    "field": CustomerInvoiceFromControlNames.BILLING_SEARCH_MODE,
                    "operator": "EQUALS",
                    "value": BillingSearchMode.BY_CONTAINER
                  }
                ]
              },
              "disabled": {
                "logic": "OR",
                "rules": [
                  {
                    "field": CustomerInvoiceFromControlNames.CUSTOMER_ID,
                    "operator": "EQUALS",
                    "value": null
                  },
                  {
                    "field": CustomerInvoiceFromControlNames.CYCLE,
                    "operator": "EQUALS",
                    "value": null
                  },
                  {
                    "field": CustomerInvoiceFromControlNames.DATE_RANGE,
                    "operator": "EQUALS",
                    "value": null
                  }
                ]
              }
            }
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.ITEM_IDS,
            "displayLabel": "Items",
            "placeHolder": "Select Items",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": DynamicFromDataType.PICKLIST,
              "lookupDetails": {
                "apiUrl": "v1/items/list",
                "filterByKeys": ["DOCUMENT_NO_CONTAINS"],
                "multiSelect": true,
                "limit": 10,
                "orderBy": {
                  "documentNo": "asc"
                },
                "bindLabel": "documentNo",
                "bindValue": "id",
                "displayColumns": [
                  { "key": "documentNo", "header": "Document No" }
                ],
                "additionalFilters": []
              }
            },
            "conditions": {
              "visibility": {
                "logic": "AND",
                "rules": [
                  {
                    "field": CustomerInvoiceFromControlNames.BILLING_SEARCH_MODE,
                    "operator": "EQUALS",
                    "value": BillingSearchMode.BY_DOCUMENT
                  }
                ]
              },
              "disabled": {
                "logic": "OR",
                "rules": [
                  {
                    "field": CustomerInvoiceFromControlNames.CUSTOMER_ID,
                    "operator": "EQUALS",
                    "value": null
                  },
                  {
                    "field": CustomerInvoiceFromControlNames.CYCLE,
                    "operator": "EQUALS",
                    "value": null
                  },
                  {
                    "field": CustomerInvoiceFromControlNames.DATE_RANGE,
                    "operator": "EQUALS",
                    "value": null
                  }
                ]
              }
            }
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.CHARGE_GROUP_ID,
            "displayLabel": "Charge Group",
            "disabled": false,
            returnRawValue: true,
            "placeHolder": "Select Charge Group",
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/charge-groups/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Charge Group is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.CHARGE_SELECTION_MODE,
            "displayLabel": "Charge Selection Mode",
            "disabled": false,
            "placeHolder": "Select Charge Selection Mode",
            "fieldInfo": {
              "dataType": "select",
              "options": Object.values(CHARGE_SELECTION_MODE),
              displayKey: 'label',
              valueKey: 'value'
            },
            "validators": [
              {
                "type": "required",
                "message": "Charge Selection Mode is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.BILLING_PARTY_TYPE,
            "displayLabel": "Billing Party Type",
            "disabled": false,
            "placeHolder": "Select Billing Party Type",
            "fieldInfo": {
              "dataType": "select",
              "options": Object.values(CustomerTypes),
              displayKey: 'name',
              valueKey: 'value'
            }
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.BILLING_PARTY,
            "displayLabel": "Billing Party",
            "disabled": false,
            "placeHolder": "Select Billing Party",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "options": [],
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": [
                      "true"
                    ]
                  }
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  },
                  {
                    "key": "code",
                    "header": "Code"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "autocompleteRequired",
                "message": "Billing Party is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.BILLING_ADDRESS,
            "displayLabel": "Billing Address",
            "disabled": false,
            "placeHolder": "Enter Billing Address",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "select",
              "options": [],
            },
            "conditions": {
              "disabled": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "billingPartyId",
                    "operator": "EQUALS",
                    "value": null
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Billing Address is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "paymentTerm",
            "displayLabel": "Payment Term",
            "disabled": false,
            "placeHolder": "Select Payment Term",
            "fieldInfo": {
              "dataType": "select",
              "options": [
                {
                  "label": "Cash/Immediate",
                  "value": "CASH"
                },
                {
                  "label": "Credit",
                  "value": "CREDIT"
                },
                {
                  "label": "PDA",
                  "value": "PDA"
                }
              ]
            },
            "validators": [
              {
                "type": "required",
                "message": "Payment Term is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": CustomerInvoiceFromControlNames.PAYING_PARTY_ID,
            "displayLabel": "Paying Party",
            "disabled": false,
            "placeHolder": "Select Paying Party",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": [
                      "true"
                    ]
                  }
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  },
                  {
                    "key": "code",
                    "header": "Code"
                  }
                ]
              }
            },
            "conditions": {
              "visibility": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "paymentTerm",
                    "operator": "EQUALS",
                    "value": "PDA"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Paying Party is required"
              }
            ]
          }
        }
      ]
    }
  ]
}
